import { cx } from 'class-variance-authority';
import type { ClassValue } from 'class-variance-authority/types';

import { customTwMerge } from '@/app/utils/custom-tw-merge';

export function cn(...args: ClassValue[]) {
  return customTwMerge(cx(args));
}
